"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _DrupalHtmlNugget = _interopRequireDefault(require("./DrupalHtmlNugget.scss"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _HtmlNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/HtmlNugget"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _FullscreenOverlay = _interopRequireDefault(require("../../FullscreenOverlay/FullscreenOverlay"));

var _reactZoomPanPinch = require("react-zoom-pan-pinch");

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _FeedbackService = require("../../../../KESI2/Services/FeedbackService");

var _htmlReactParser = _interopRequireWildcard(require("html-react-parser"));

var _ZoomOutMap = _interopRequireDefault(require("@material-ui/icons/ZoomOutMap"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _DateTimeHelper = require("../../../../helpers/DateTimeHelper");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'htmlContainer_';

var DrupalHtmlNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalHtmlNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalHtmlNugget);

  function DrupalHtmlNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalHtmlNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getInnerHtmlId", function () {
      return "".concat(_this.getDomId(), "_html");
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getPrerenderId", function () {
      return "".concat(_this.getDomId(), "_prerender");
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "imgToFullScreen", function (imgSrc) {
      return _this.setState({
        showFullscreenOverlay: true,
        fullScreenImg: imgSrc
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "imgExitFullScreen", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.setState({
                showFullscreenOverlay: false,
                fullScreenImg: null
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "readMore", function () {
      return _this.setState({
        readMore: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setScale", function (values) {
      if ((values === null || values === void 0 ? void 0 : values.scale) > 1 && _this.state.scrollingEnabled) _this.setState({
        scrollingEnabled: false
      });else if ((values === null || values === void 0 ? void 0 : values.scale) === 1 && !_this.state.scrollingEnabled) _this.setState({
        scrollingEnabled: true
      });
    });
    _this.state = _objectSpread({
      waitingForActivation: false,
      region: null,
      readMore: false,
      showFullscreenOverlay: false,
      fullScreenImg: null,
      scrollingEnabled: true,
      imgRotation: 0
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;

    _this.props.registerNugget(_this.props.id, _HtmlNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalHtmlNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalHtmlNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _HtmlNugget["default"].CLASS, this.getDomId());
      if (this.props.inListContainer) this.props.setBackButtonFunc(this.props.goUpFunc);
      this.props.markAsRead(this.props.id);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalHtmlNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;
      if (this.state.waitingForActivation && active !== this.active) this.setState({
        waitingForActivation: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalHtmlNugget.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {HtmlNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var data = _DeviceInfoHelper["default"].isBrowser() ? nugget.template.replace('{theme}', nugget.theme) : nugget.template.replace('{theme}', nugget.theme).replace(/{resourcePath}/g, this.props.path); // allow links to external tabs for further informations

      var sanitizedHtml = _dompurify["default"].sanitize(data, {
        ALLOW_UNKNOWN_PROTOCOLS: true,
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['target']
      });

      var sanitizedLinkReplacedHtml = sanitizedHtml;

      var userProfile = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.USER_PROFILE);

      var hasUserMail = sanitizedLinkReplacedHtml.indexOf('$USER_MAIL') > -1;
      if (_config["default"].useLoginMailForGWGCert && hasUserMail && userProfile && userProfile.email) sanitizedLinkReplacedHtml = sanitizedLinkReplacedHtml.replace('$USER_MAIL', userProfile.email);
      var hasReadMore = sanitizedLinkReplacedHtml.indexOf('---READMORE---') > -1;

      if (!this.state.readMore && hasReadMore) {
        var htmlParts = sanitizedLinkReplacedHtml.split('---READMORE---');
        sanitizedLinkReplacedHtml = htmlParts[0];
      } else if (this.state.readMore && hasReadMore) {
        var _htmlParts = sanitizedLinkReplacedHtml.split('---READMORE---');

        sanitizedLinkReplacedHtml = _htmlParts[0] + _htmlParts[1];
      }

      var demoMode = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_DEMO_MODE);

      var hasResetButtonSchichtarbeit = _config["default"].showDayInfoOnTile && sanitizedLinkReplacedHtml.indexOf('--!RESET_BUTTON_SCHICHTARBEIT!--') > -1;

      if (hasResetButtonSchichtarbeit) {
        var _htmlParts2 = sanitizedLinkReplacedHtml.split('--!RESET_BUTTON_SCHICHTARBEIT!--');

        if (_htmlParts2.length > 1) sanitizedLinkReplacedHtml = _htmlParts2[0] + _htmlParts2[1];else sanitizedLinkReplacedHtml = _htmlParts2[0];
      }

      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT); // TODO: always repalce <img /> with Image component + use enhanced image if available + cleanup


      var replaceHTMLOptions = {
        replace: function replace(node) {
          if (node.attribs && node.name === 'a') {
            var child = node.children.length > 0 ? node.children[0] : null;

            if (_config["default"].replaceDrupalLinks && node.attribs.href && node.attribs.href.indexOf('drupalid') !== -1) {
              var ids = node.attribs.href.split(':');
              var id = ids[ids.length - 1];

              if (id) {
                var content = _KESI2Helper["default"].getContentById(id);

                var path = _KESI2Helper["default"].getPathToContentInTree(id);

                if (content && path) {
                  if (path.length > 1 && content.type === 'nugget') (0, _ArrayHelper.removeElementAtPosition)(path, path.length - 1); // Remove the last element if it was a nugget, cant link to nuggets right now

                  var stringPath = "".concat(_config["default"].baseRoute, "/").concat(path.join('!'));
                  var prevUrl = "".concat(_config["default"].baseRoute, "/").concat(_this2.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER));
                  return /*#__PURE__*/_react["default"].createElement("a", {
                    className: _Nugget["default"].link,
                    onClick: function onClick() {
                      if (_this2.props.closePrevDialogFn) _this2.props.closePrevDialogFn();

                      if (prevUrl === "".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId)) {
                        prevUrl = null;
                      }

                      window.goToKesiUrl(stringPath ? stringPath : _config["default"].cordovaStartUrl(), prevUrl);
                    }
                  }, child ? child.data : 'No text!');
                }
              }
            } else if (!_DeviceInfoHelper["default"].isBrowser()) {
              return /*#__PURE__*/_react["default"].createElement("a", {
                className: _Nugget["default"].link,
                href: "javascript:",
                onClick: function onClick() {
                  return window.open(node.attribs.href, '_system');
                }
              }, child ? child.data : 'Kein Text hinterlegt');
            } else return node;
          } else if (node.attribs && node.name === 'img' && _config["default"].addZoomClickToImages) {
            var className = "handled ".concat(_DrupalHtmlNugget["default"].zoomContainer, " ").concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobileImg', " zoomableImage");
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: className,
              onClick: _config["default"].imgFullScreenOnClick && nugget.pictureZoomable ? function () {
                return _this2.imgToFullScreen(node.attribs.src);
              } : null
            }, _config["default"].showZoomIcon && nugget.pictureZoomable && /*#__PURE__*/_react["default"].createElement(_ZoomOutMap["default"], {
              className: "".concat(_DrupalHtmlNugget["default"].zoomIcon, " zoomIcon")
            }), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
              alt: "Zoomicon",
              src: node.attribs.src,
              key: node.attribs.key
            }));
          } else if (node.attribs && node.name === 'img') {
            return /*#__PURE__*/_react["default"].createElement(_Image["default"], {
              alt: "Bild",
              src: node.attribs.src,
              key: node.attribs.key
            });
          }
        }
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "htmlContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons && this.props.renderIcon(nugget), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), /*#__PURE__*/_react["default"].createElement("div", {
        id: this.getInnerHtmlId(),
        className: "HtmlNugget_".concat(this.props.id)
      }, (0, _htmlReactParser["default"])(sanitizedLinkReplacedHtml, replaceHTMLOptions)), !this.state.readMore && hasReadMore && /*#__PURE__*/_react["default"].createElement("div", {
        onClick: this.readMore
      }, /*#__PURE__*/_react["default"].createElement("u", null, "Mehr lesen...")), hasResetButtonSchichtarbeit && !demoMode && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: _DateTimeHelper.resetWeek,
        className: _DrupalHtmlNugget["default"].resetButton
      }, "Woche zur\xFCcksetzen")), /*#__PURE__*/_react["default"].createElement("div", {
        id: this.getPrerenderId(),
        style: {
          opacity: 0,
          width: 0,
          position: 'fixed',
          left: -10000,
          top: -10000
        }
      }), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer && /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))), /*#__PURE__*/_react["default"].createElement(_FullscreenOverlay["default"], {
        open: this.state.showFullscreenOverlay,
        backgroundColor: this.props.lectureBackgroundColor
      }, /*#__PURE__*/_react["default"].createElement(_reactZoomPanPinch.TransformWrapper, {
        panningEnabled: !this.state.scrollingEnabled,
        onPinching: function onPinching(values) {
          return _this2.setScale(values);
        },
        enableZoomedOutPanning: true,
        minScale: 1,
        defaultScale: 1
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalHtmlNugget["default"].iconContainer
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        color: "primary",
        className: _DrupalHtmlNugget["default"].icon,
        style: {
          color: this.props.lectureBackgroundColor && (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : _cssConstants["default"].colorMap[this.props.lectureBackgroundColor]) || _cssConstants["default"].colors.buttonBackground
        },
        onClick: this.imgExitFullScreen
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          transform: "rotate(".concat(this.state.imgRotation, "deg)")
        },
        className: _DrupalHtmlNugget["default"].portraitOverlayImgContainer
      }, /*#__PURE__*/_react["default"].createElement(_reactZoomPanPinch.TransformComponent, null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "Schlie\xDFen-Icon",
        className: _DrupalHtmlNugget["default"].fullScreenOverlayImg,
        src: this.state.fullScreenImg && this.state.fullScreenImg
      }))))));
    }
  }]);
  return DrupalHtmlNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalHtmlNugget;
DrupalHtmlNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  region: _propTypes["default"].string,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired,
  inTutorial: _propTypes["default"].bool,
  lectureBackgroundColor: _propTypes["default"].string,
  setLike: _propTypes["default"].func,
  closePrevDialogFn: _propTypes["default"].func
};
DrupalHtmlNugget.defaultProps = {
  id: null
};